import { render, staticRenderFns } from "./offerProducts.vue?vue&type=template&id=1232e570&scoped=true&"
import script from "./offerProducts.vue?vue&type=script&lang=js&"
export * from "./offerProducts.vue?vue&type=script&lang=js&"
import style0 from "./offerProducts.vue?vue&type=style&index=0&id=1232e570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232e570",
  null
  
)

export default component.exports